import {
  Directive,
  Inject,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { IS_SERVER_PLATFORM } from 'src/app/core';

@Directive({
  selector: '[ifIsBrowser]',
})
export class IfIsBrowserDirective {
  constructor(
    @Inject(IS_SERVER_PLATFORM) isServer: boolean,
    templateRef: TemplateRef<any>,
    viewContainer: ViewContainerRef
  ) {
    if (!isServer) {
      viewContainer.createEmbeddedView(templateRef);
    }
  }
}
